import {createFileRoute} from '@tanstack/react-router'
import React from "react";
import Master_ReferralsView from "../../../master/Master_ReferralsView.tsx";

export const Route = createFileRoute('/_app/master/referrals')({
    component: RouteComponent,
})

function RouteComponent() {
    return <Master_ReferralsView />
}
